import Vue from 'vue'
import VueRouter from 'vue-router'

//引入页面
import index from "./subpages/index"

Vue.use(VueRouter)

export default new VueRouter({
	routes: [{
		path: '/',
		name: 'index',
		// component: () => import ("./subpage/BugAdd"),//懒加载
		component: index,
		meta: {
			title: ['BugX-智慧云工程进度质量管理',"Home Page"]
		}
	}]
})
